import { render } from "./AccountManagePage.vue?vue&type=template&id=4b167228&scoped=true"
import script from "./AccountManagePage.vue?vue&type=script&lang=js"
export * from "./AccountManagePage.vue?vue&type=script&lang=js"

import "./AccountManagePage.vue?vue&type=style&index=0&id=4b167228&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b167228"]])

export default __exports__